import { IsBoolean, IsOptional, IsString, MaxLength } from 'class-validator';

export class CreateMedicalDeviceReleaseConfigRequestDto {
    @IsOptional()
    @IsString()
    @MaxLength(50)
    deviceClass?: string;

    /**
     * Are medical devices received into quarantine?
     * @example false
     */
    @IsOptional()
    @IsBoolean()
    receivedIntoQuarantine?: boolean;

    /**
     * Is verification by QC required?
     * @example false
     */
    @IsOptional()
    @IsBoolean()
    verificationByQcRequired?: boolean;

    /**
     * Is destruction approved by QC?
     * @example false
     */
    @IsOptional()
    @IsBoolean()
    destructionApprovedByQc?: boolean;

    /**
     * Notes on medical device release process
     * @example 'N/A - Not applicable for Jazz products'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}
